export interface SVGProps {
  fill?: string;
  stroke?: string;
  size?: number;
  strokeWidth?: number;
}

const Circle = ({fill="white", stroke="black", size=10, strokeWidth=40}: SVGProps) => (
  <svg viewBox="0 0 1000 1000" width={size} height={size}>
    <circle cx="500" cy="500" r="450"
      fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
  </svg>
)

const Square = ({fill="white", stroke="black", size=10, strokeWidth=40}: SVGProps) => (
  <svg viewBox="0 0 1000 1000" width={size} height={size}>
    <rect x="50" y="50" width="900" height="900"
      fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
  </svg>
)

const Triangle = ({fill="white", stroke="black", size=10, strokeWidth=40}: SVGProps) => (
  <svg viewBox="0 0 1000 1000" width={size} height={size}>
    <polygon points="50 50, 450 950, 950 50"
      fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
  </svg>
)

const Diamond = ({fill="white", stroke="black", size=10, strokeWidth=40}: SVGProps) => (
  <svg viewBox="0 0 1000 1000" width={size} height={size}>
    <polygon points="50 500, 500 50, 950 500, 500 950"
      fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
  </svg>
)

const figures = {
  circle: Circle,
  square: Square,
  triangle: Triangle,
  diamond: Diamond,
};

export default figures;